// Module
var code = "<ul ng-if=properties.length ng-attr-style=\"{{:: node.style }}\"> <li ng-repeat=\"property in ::properties\" class=nlgAnalysisTreeProperty ng-attr-style={{::propertyStyle(property)}} nlg-analysis-tree-property node=::node property=::property> </li> </ul>";
// Exports
module.exports = code;